export const searchInputParamName = "search";